import { Component, Input } from '@angular/core';
import { AbstractControl, ValidationErrors } from '@angular/forms';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { FormError } from '@aeCore/enums/form-error';
import { TranslateWithFallbackPipe } from '@aeShared/pipes/translate-with-fallback.pipe';

@Component({
  selector: 'app-ae-form-error',
  standalone: true,
  imports: [TranslateModule, TranslateWithFallbackPipe],
  templateUrl: './ae-form-error.component.html',
  styleUrl: './ae-form-error.component.scss',
})
export class AeFormErrorComponent {
  @Input() field!: AbstractControl<unknown>;

  constructor(private translate: TranslateService) {}

  formErrors: typeof FormError = FormError;

  translateCompareField(
    errors: ValidationErrors,
    errorCode: FormError,
  ): string {
    const compareField = errors[errorCode]?.compareField ?? [];
    return compareField
      .map((field: string) => this.translate.instant(field))
      .join(', ');
  }
}
